import { createContext } from 'react';
import type { Map3DSideBarContextType } from './types';

export const Map3DSideBarContext = createContext<Map3DSideBarContextType>({
  activeOptionHandler: () => undefined,
  hideSidecard: () => undefined,
});
